const INFO = "info";
const ACTUALITY = "actuality";
const EVENT = "event";

export {INFO,ACTUALITY,EVENT}
